import Eye from "../../asset/image/eye.png";
import { Button, Image, Input, Popconfirm, Rate, Select, Switch } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  BellOutlined,
  StarFilled,
} from "@ant-design/icons";
import moment from "moment/moment";
import logo from "../../asset/logos/icon.svg";
import stars from "../../asset/icons/star.svg";
import emptyStars from "../../asset/icons/emptyStar.svg";

const alphanumericSort = (a, b, value) => {
  if (isNaN(parseInt(a[value]))) {
    return a[value]?.localeCompare(b[value]);
  }
  return a[value] - b[value];
};

const RenderActionButtons = (value) => {
  let ButtonsArray = [];
  if (value?.Delete) {
    ButtonsArray.push(RenderDeleteButton(value.Delete));
  }
  if (value?.Edit) {
    ButtonsArray.push(RenderEditButton(value.Edit));
  }
  if (value?.View) {
    ButtonsArray.push(RenderViewButton(value.View));
  }
  if (value?.Download) {
    ButtonsArray.push(RenderDownloadButton(value.Download));
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        // paddingRight: "5px",
      }}
    >
      {ButtonsArray?.map((el, i) => (
        <div key={i}>{el}</div>
      ))}
    </div>
  );
};

// Delete Button
const RenderDeleteButton = (value) => {
  const { id, onClick } = value;
  return (
    <Popconfirm title="Sure to Delete?" onConfirm={() => onClick(id)}>
      <Button type="primary">
        {value?.name ? value?.name : <DeleteOutlined />}
      </Button>
      {/* <Button type="primary">{value?.name}</Button> */}
    </Popconfirm>
  );
};

// Delete button without confimation model
const RenderDeleteWithoutConfirmation = (value) => {
  return (
    <Popconfirm
      title="Sure to Delete?"
      open={false}
      onOpenChange={() => value?.onClick(value.key)}
      onConfirm={() => value?.onClick(value.key)}
    >
      {value?.name ? (
        value?.name
      ) : (
        <DeleteOutlined style={{ color: "black" }} />
      )}
    </Popconfirm>
  );
};
// Download Button
const RenderDownloadButton = (value) => {
  return (
    <DownloadOutlined
      onClick={() => {
        window.open(value, "Download");
      }}
    />
  );
};

// Edit Button
const RenderEditButton = (value) => {
  const { id, onClick, disabled = false } = value;
  return (
    <Button
      type="primary"
      disabled={disabled}
      onClick={() => {
        onClick(id);
      }}
    >
      <EditOutlined />
    </Button>
  );
};

// View Image Button
const RenderViewImageButton = (value) => {
  return (
    <Image
      width={20}
      src={Eye}
      className="pointer"
      preview={{
        mask: false,
        src: value,
      }}
    />
  );
};

// Render Accept and Reject Button
const RenderAcceptRejectButton = (value) => {
  const { id, onAccept, onReject } = value;

  return (
    <div>
      <Popconfirm
        placement="top"
        title={"Are you sure to Accept this request?"}
        // description={description}
        onConfirm={() => {
          onAccept(id);
        }}
        okText="Yes"
        cancelText="No"
      >
        <Button style={{ backgroundColor: "#52c41a" }}>
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        </Button>
      </Popconfirm>
      <Popconfirm
        placement="top"
        title={"Are you sure to Reject this request?"}
        // description={description}
        onConfirm={() => {
          onReject(id);
        }}
        okText="Yes"
        cancelText="No"
      >
        <Button className="ml-2 bg-red-600">
          <CloseCircleTwoTone twoToneColor="#dc2626" />
        </Button>
      </Popconfirm>
    </div>
  );
};

// Render View Button
const RenderViewButton = (value) => {
  // console.log(value);
  const { id = null, onClick = () => { } } = value;
  return (
    <Button
      onClick={() => {
        // console.log('click');
        onClick(id);
      }}
      type="primary"
    >
      <EyeOutlined />
    </Button>
  );
};

// Render View Button
const RenderNotificationButton = (value) => {
  // console.log(value);
  const { id = null, onClick = () => { } } = value;
  return (

    <Button
      onClick={() => {
        onClick(id);
      }}
      type="primary"
    >
      <BellOutlined />
    </Button>
  );
};

// Render Images
const ImageRanders = (value) => {
  // console.log(value);
  let imageSrc = value;
  if (!imageSrc) {
    imageSrc = logo;
  }
  return (
    <div>
      <Image
        width={50}
        height={50}
        className="rounded-full object-cover"
        src={imageSrc}
        alt={value}
      />
    </div>
  );
};

// Toggle Button
const RenderToggleButton = (value) => {
  // console.log(value);
  const { checked, id, onClick } = value;
  return (
    <div>
      <Switch
        onChange={() => {
          onClick(id, checked);
        }}
        checked={!checked}
      />
    </div>
  );
};

// OR Button
const RenderQrButton = (value = {}) => {
  const { id, onClick } = value;
  return (
    <Button
      type="primary"
      onClick={() => {
        onClick(id);
      }}
    >
      Generate QR
    </Button>
  );
};

// Ratings
const RenderRating = (value) => {
  // console.log(value);
  const { ratings } = value;
  return (
    <div>
      {/* {ratings}&nbsp;< StarFilled /> */}

      <Rate
        disabled
        allowHalf
        value={ratings}
        character={({ index }) => {
          if (index < ratings) {
            return <img src={stars} />;
          } else {
            return <img src={emptyStars} />;
          }
        }}
      />
    </div>
  );
};

// Checkbox render
const RenderCheckbox = (value) => {
  const { checked, id, onClick } = value;
  return (
    <div>
      <Input
        type="checkbox"
        checked={!checked}
        onChange={() => {
          onClick(id, checked);
        }}
      />
    </div>
  );
};

export const loginRoot = "/";
export const appRoot = "/app";

const CONSTANTS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  GETMe: null,
  TABLE: {
    USERS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
      },
      {
        title: "Profile",
        dataIndex: "profilePic",
        render: ImageRanders,
        width: 70,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Mobile No.",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 110,
      },

      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 130,
      },

      {
        title: "Notification",
        dataIndex: "notification",
        render: RenderNotificationButton,
        width: 70,
      },
    ],

    USER_PETS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 80,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Species",
        dataIndex: "species",
        sorter: (a, b) => alphanumericSort(a, b, "species"),
        width: 100,
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 100,
      },

      {
        title: "DOB",
        dataIndex: "dob",
        sorter: (a, b) => alphanumericSort(a, b, "dob"),
        width: 110,
      },
      {
        title: "Height (in)",
        dataIndex: "height",
        sorter: (a, b) => alphanumericSort(a, b, "height"),
        width: 120,
      },

      {
        title: "Gender",
        dataIndex: "gender",
        sorter: (a, b) => alphanumericSort(a, b, "gender"),
        width: 100,
      },
      // {
      //   title: "Device Type",
      //   dataIndex: "type",
      //   sorter: (a, b) => alphanumericSort(a, b, "type"),
      // },
      // {
      //   title: "Active",
      //   dataIndex: "isActive",
      //   sorter: (a, b) => alphanumericSort(a, b, "isActive"),
      // },

      // {
      //   title: "Block Pet",
      //   dataIndex: "isBlocked",
      //   render: RenderToggleButton,
      //   width: 100,
      //   // sorter: (a, b) => alphanumericSort(a, b, "no"),
      // },
    ],

    USER_FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 50,
      },

      {
        title: "Feedback",
        dataIndex: "feedback",
        sorter: (a, b) => alphanumericSort(a, b, "feedback"),
        width: 250,
      },
      {
        title: "Ratings",
        dataIndex: "rating",
        render: RenderRating,
        width: 80,
      },
    ],

    USER_SUBSCRIPTION: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        // width: 100,
      },
      {
        title: "Subscription Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        // width: 100,
      },
      {
        title: "Pet Name",
        dataIndex: "petName",
        sorter: (a, b) => alphanumericSort(a, b, "petName"),
        // width: 100,
      },
      {
        title: "Subscription Status",
        dataIndex: "status",
        sorter: (a, b) => alphanumericSort(a, b, "status"),
        // width: 100,
      },
      {
        title: "Subscription End Date",
        dataIndex: "expiryDate",
        sorter: (a, b) => alphanumericSort(a, b, "expiryDate"),
        // width: 100,
      },
    ],
    USER_TRANSACTION: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Payment Type",
        dataIndex: "paymentType",
        sorter: (a, b) => alphanumericSort(a, b, "paymentType"),
        width: 100,
      },
      {
        title: "Payment Id",
        dataIndex: "paymentId",
        sorter: (a, b) => alphanumericSort(a, b, "paymentId"),
        width: 120,
      },
      {
        title: "Payment Method",
        dataIndex: "paymentMethod",
        sorter: (a, b) => alphanumericSort(a, b, "paymentMethod"),
        width: 100,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        sorter: (a, b) => alphanumericSort(a, b, "amount"),
        width: 100,
      },
      {
        title: "Payment Status",
        dataIndex: "status",
        sorter: (a, b) => alphanumericSort(a, b, "status"),
        width: 100,
      },
    ],

    PETS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 80,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "User",
        dataIndex: "user",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 150,
      },
      {
        title: "Species",
        dataIndex: "species",
        sorter: (a, b) => alphanumericSort(a, b, "species"),
        width: 100,
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 150,
      },

      {
        title: "DOB",
        dataIndex: "dob",
        sorter: (a, b) => alphanumericSort(a, b, "dob"),
        width: 110,
      },
      {
        title: "Height (in)",
        dataIndex: "height",
        sorter: (a, b) => alphanumericSort(a, b, "height"),
        width: 120,
      },

      {
        title: "Gender",
        dataIndex: "gender",
        sorter: (a, b) => alphanumericSort(a, b, "gender"),
        width: 100,
      },
      // {
      //   title: "Device Type",
      //   dataIndex: "type",
      //   sorter: (a, b) => alphanumericSort(a, b, "type"),
      // },
      // {
      //   title: "Active",
      //   dataIndex: "isActive",
      //   sorter: (a, b) => alphanumericSort(a, b, "isActive"),
      // },

      // {
      //   title: "Block Pet",
      //   dataIndex: "isBlocked",
      //   render: RenderToggleButton,
      //   width: 100,
      //   // sorter: (a, b) => alphanumericSort(a, b, "no"),
      // },
    ],
    PETS_FOOD_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },


      {
        title: "Product",
        dataIndex: "product",
        sorter: (a, b) => alphanumericSort(a, b, "product"),
        width: 150,
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        sorter: (a, b) => alphanumericSort(a, b, "quantity"),
        width: 100,
      },
      {
        title: "Food Type",
        dataIndex: "foodType",
        sorter: (a, b) => alphanumericSort(a, b, "foodType"),
        width: 100,
      },
      {
        title: "Food Brand",
        dataIndex: "foodBrand",
        sorter: (a, b) => alphanumericSort(a, b, "foodBrand"),
        width: 100,
      },
      {
        title: "Meal Date",
        dataIndex: "mealDate",
        sorter: (a, b) => alphanumericSort(a, b, "mealDate"),
        width: 100,
      },
      {
        title: "Meal Time",
        dataIndex: "mealTime",
        sorter: (a, b) => alphanumericSort(a, b, "mealTime"),
        width: 100,
      },

    ],
    PETS_WEIGHT_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Weight",
        dataIndex: "weight",
        sorter: (a, b) => alphanumericSort(a, b, "weight"),
        width: 100,
      },
      {
        title: "RIB Test",
        dataIndex: "RIBTest",
        sorter: (a, b) => alphanumericSort(a, b, "RIBTest"),
        width: 100,
      },
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
      {
        title: "isSprayed",
        dataIndex: "isSprayed",
        // sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
      {
        title: "isNeutered",
        dataIndex: "isNeutered",
        // sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
    ],
    PETS_MANUALLY_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Activity",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Duration",
        dataIndex: "duration",
        sorter: (a, b) => alphanumericSort(a, b, "duration"),
        width: 100,
      },
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
    ],

    BENCHMARK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 140,
      },
      {
        title: "Size",
        dataIndex: "size",
        sorter: (a, b) => alphanumericSort(a, b, "size"),
        width: 90,
      },
      {
        title: "Female Lower Weight (kg)",
        dataIndex: "lowerWeightFemale",
        sorter: (a, b) => alphanumericSort(a, b, "lowerWeightFemale"),
        width: 140,
      },
      {
        title: "Female Higher Weight (kg)",
        dataIndex: "heigherWeightFemale",
        sorter: (a, b) => alphanumericSort(a, b, "heigherWeightFemale"),
        width: 150,
      },
      {
        title: "Male Lower Weight (kg)",
        dataIndex: "lowerWeightMale",
        sorter: (a, b) => alphanumericSort(a, b, "lowerWeightMale"),
        width: 140,
      },
      {
        title: "Male Higher Weight (kg)",
        dataIndex: "heigherWeightMale",
        sorter: (a, b) => alphanumericSort(a, b, "heigherWeightMale"),
        width: 140,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },

    ],
    BENCHMARK_ACTIVITY: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },



      {
        title: "Start Age",
        dataIndex: "startAge",
        sorter: (a, b) => alphanumericSort(a, b, "startAge"),
        width: 100,
      },
      {
        title: "End Age",
        dataIndex: "endAge",
        sorter: (a, b) => alphanumericSort(a, b, "endAge"),
        width: 100,
      },
      {
        title: "Walk Time (Min)",
        dataIndex: "walkTime",
        sorter: (a, b) => alphanumericSort(a, b, "walkTime"),
        width: 100,
      },
      {
        title: "Play Time (Min)",
        dataIndex: "playTime",
        sorter: (a, b) => alphanumericSort(a, b, "playTime"),
        width: 100,
      },
      {
        title: "Sleep Time (Min)",
        dataIndex: "sleepTime",
        sorter: (a, b) => alphanumericSort(a, b, "sleepTime"),
        width: 100,
      },
      {
        title: "Rest Time (Min)",
        dataIndex: "restTime",
        sorter: (a, b) => alphanumericSort(a, b, "restTime"),
        width: 100,
      },


      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },

    ],
    FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 90,
      },
      {
        title: "User",
        dataIndex: "user",
        sorter: (a, b) => alphanumericSort(a, b, "user"),
        width: 100,
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 100,
      },
      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 130,
      },

      {
        title: "Feedback",
        dataIndex: "feedback",
        sorter: (a, b) => alphanumericSort(a, b, "feedback"),
        width: 190,
      },
      {
        title: "Ratings",
        dataIndex: "rating",
        render: RenderRating,
        width: 150,
      },
    ],
    DEVICETYPE: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 70,
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 70,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => alphanumericSort(a, b, "type"),
        width: 70,
      },
      {
        title: "Title",
        dataIndex: "title",
        sorter: (a, b) => alphanumericSort(a, b, "title"),
        width: 70,
      },
      {
        title: "Description",
        dataIndex: "description",
        sorter: (a, b) => alphanumericSort(a, b, "description"),
        width: 150,
      },
      {
        title: "Price (₹)",
        dataIndex: "price",
        sorter: (a, b) => alphanumericSort(a, b, "price"),
        width: 60,
      },
    ],

    DEVICE_1: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Unique Id",
        dataIndex: "uniqueId",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 180,
      },


      {
        title: "Device Active Status",
        dataIndex: "isActive",
        render: RenderToggleButton,
        width: 130,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },


      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 130,
      },
    ],

    DEVICE_2: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Unique Id",
        dataIndex: "uniqueId",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 180,
      },

      {
        title: "Sim Id",
        dataIndex: "simId",
        sorter: (a, b) => alphanumericSort(a, b, "simId"),
        width: 100,
      },
      {
        title: "Device Active Status",
        dataIndex: "isActive",
        render: RenderToggleButton,
        width: 130,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },

      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 130,
      },
    ],


    PLAN: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
      },

      {
        title: "Plan Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Features",
        dataIndex: "feature",
        sorter: (a, b) => alphanumericSort(a, b, "feature"),
        width: 110,
      },

      {
        title: "Accessible Device",
        dataIndex: "accessibleDevice",
        sorter: (a, b) => alphanumericSort(a, b, "accessibleDevice"),
        width: 130,
      },


    ],
    SUB_PLAN: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },


      {
        title: "Plan Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Price (₹)",
        dataIndex: "price",
        sorter: (a, b) => alphanumericSort(a, b, "price"),
        width: 100,
      },
      {
        title: "Duration (Months)",
        dataIndex: "duration",
        sorter: (a, b) => alphanumericSort(a, b, "duration"),
        width: 100,
      },
      {
        title: "Offer Price (₹)",
        dataIndex: "offerPrice",
        sorter: (a, b) => alphanumericSort(a, b, "offerPrice"),
        width: 100,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },

    ],
  },
  FORM_FIELD: {
    LOGIN_PAGE_MODAL: [
      {
        no: 1,
        // Label: "User Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "User name",
        required: true,
        width: 24,
      },
      {
        no: 1,
        // Label: "Password",
        name: "password",
        width: 24,
        id: "password",
        type: "password",
        placeholder: "Password",
        required: true,
      },
    ],
    USERS_MODAL: [
      {
        no: 1,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Your Name",
        required: true,
        labelwidth: 5,
      },

      {
        no: 2,
        Label: "Mobile Number",
        name: "mobile",
        id: "mobile",
        type: "mobile",
        placeholder: "Enter Mobile Number",
        required: true,
        labelwidth: 5,
        // width: 20,
      },
      {
        no: 3,
        Label: "Username",
        name: "user",
        id: "user",
        type: "text",
        placeholder: "Enter User Name",
        // required: true,
        labelwidth: 8,
        width: 8,
      },

      {
        no: 4,
        Label: "Date of Birth",
        name: "date",
        id: "date",
        type: "date",
        placeholder: "Enter Date of Birth",
        required: true,
        labelwidth: 8,
        width: 8,
      },
      {
        no: 5,
        Label: "Profile Picture",
        name: "profilePic",
        id: "profilePic",
        type: "file",
        placeholder: " ",
        required: true,
        labelwidth: 8,
        width: 8,
      },
    ],
    TECHNOLOGY_MODAL: [
      {
        no: 1,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Your Name",
        required: true,
      },
      {
        no: 1,
        Label: "Price",
        name: "price",
        id: "price",
        type: "number",
        placeholder: "Enter Your price",
        required: true,
      },
    ],
    NOTIFICATION_MODAL: [
      {
        no: 1,
        Label: "Notification Type",
        name: "type",
        id: "type",
        type: "select",
        placeholder: "Select a Notification Type",
        required: true,
        option: [
          {
            label: 'General ',
            value: 'General ',
          },
          {
            label: 'Reminder',
            value: 'Reminder',
          },


        ],
        width: 24,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "Notification Title",
        name: "notification",
        id: "notification",
        type: "text",
        placeholder: "Enter Notification Title",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Message",
        name: "body",
        id: "body",
        type: "text",
        placeholder: "Enter Message",
        required: true,
        width: 24,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Click Action",
        name: "clickAction",
        id: "clickAction",
        type: "select",
        placeholder: "Select a Click Action",
        required: true,
        option: [
          {
            label: 'Home',
            value: 'Home',
          },
          {
            label: 'Profile',
            value: 'Profile',
          },
          {
            label: 'Subscription',
            value: 'Subscription',
          },
          {
            label: 'Feedback',
            value: 'Feedback',
          },
          {
            label: 'Blog',
            value: 'Blog',
          },
        ],
        width: 24,
        labelwidth: 24,
      },
    ],
    BENCHMARK_MODAL: [

      {
        no: 1,
        Label: "Breed",
        name: "breed",
        id: "breed",
        type: "text",
        placeholder: "Enter Breed",
        required: true,
        width: 12,
        labelwidth: 24,
      },


      {
        no: 2,
        Label: "Size",
        name: "size",
        id: "size",
        type: "select",
        placeholder: "Select a Size",
        required: true,
        option: [
          {
            label: 'Small',
            value: 'Small',
          },
          {
            label: 'Medium',
            value: 'Medium',
          },
          {
            label: 'Large',
            value: 'Large',
          },
        ],
        width: 12,
        labelwidth: 24,
      },
      {
        no: 3,
        Label: "Female Lower Weight (kg)",
        name: "lowerWeightFemale",
        id: "lowerWeightFemale",
        type: "number",
        placeholder: "Enter Female Lower Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Female Higher Weight (kg)",
        name: "heigherWeightFemale",
        id: "heigherWeightFemale",
        type: "number",
        placeholder: "Enter Female Higher Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Male Lower Weight (kg)",
        name: "lowerWeightMale",
        id: "lowerWeightMale",
        type: "number",
        placeholder: "Enter Male Lower Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Male Higher Weight (kg)",
        name: "heigherWeightMale",
        id: "heigherWeightMale",
        type: "number",
        placeholder: "Enter Male Higher Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    BENCHMARK_ACTIVITY_MODAL: [

      {
        no: 1,
        Label: "Start Age",
        name: "startAge",
        id: "startAge",
        type: "number",
        placeholder: "Enter Start Age",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "End Age",
        name: "endAge",
        id: "endAge",
        type: "number",
        placeholder: "Enter End Age",
        required: true,
        width: 12,
        labelwidth: 24,
      },




      {
        no: 3,
        Label: "Walk Time",
        name: "walkTime",
        id: "walkTime",
        type: "number",
        placeholder: "Enter Walk Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Play Time",
        name: "playTime",
        id: "playTime",
        type: "number",
        placeholder: "Enter Play Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Sleep Time",
        name: "sleepTime",
        id: "sleepTime",
        type: "number",
        placeholder: "Enter Sleep Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Rest Time",
        name: "restTime",
        id: "restTime",
        type: "number",
        placeholder: "Rest Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    SUB_PLAN_MODAL: [

      {
        no: 1,
        Label: "Plan Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Plan Name",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "Price (₹)",
        name: "price",
        id: "price",
        type: "number",
        placeholder: "Enter Price (₹)",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Duration (Months)",
        name: "duration",
        id: "duration",
        type: "number",
        placeholder: "Enter Duration (Months)",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Offer Price (₹)",
        name: "offerPrice",
        id: "offerPrice",
        type: "number",
        placeholder: "Enter Offer Price (₹)",
        required: true,
        width: 12,
        labelwidth: 24,
      },

    ],
    DEVICE_MODAL: [

      {
        no: 1,
        Label: "Sim Id",
        name: "simId",
        id: "simId",
        type: "number",
        placeholder: "Enter Sim Id",
        required: true,
        width: 24,
        labelwidth: 24,
      },

    ],
  },

  API: {
    login: {
      type: "POST",
      endpoint: "/admin/admin/login",
    },

    signUp: {
      type: "POST",
      endpoint: "/user/signup",
    },

    getMe: {
      type: "GET",
      endpoint: "/admin/admin/my/profile",
    },
    getClubRequest: {
      type: "GET",
      endpoint: "/admins/clubs",
    },
    getOneClubRequest: {
      type: "GET",
      endpoint: "/admins/clubs/id/:requestId",
    },
    acceptOrRejectRequest: {
      type: "PATCH",
      endpoint: "/admins/clubs/kyc-status",
    },

    // Analytics API

    Analytics: {
      getAll: {
        type: "GET",
        endpoint: "/admin/analytics",
      },

    },

    // Users API

    User: {
      getAll: {
        type: "GET",
        endpoint: "/admin/user",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/user/:id",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/user/",
      },
      notification: {
        type: "GET",
        endpoint: "/admin/notification/addPersonalNotification",
      },
    },

    // Subsctiption API

    Subscription: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userSubscription",
      },
    },
    // Transaction API

    Transaction: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userTransaction",
      },
    },

    // Pet API

    Pet: {
      getAll: {
        type: "GET",
        endpoint: "/admin/pets",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/pets/",
      },
    },

    Pet_Food_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/foodTracking",
      },
    },
    Pet_Weight_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/weightTracking",
      },
    },
    Pet_Manually_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/manuallyTracking",
      },
    },
    Pet_Device_Details: {
      getAll: {
        type: "GET",
        endpoint: "/admin/petDevice",
      },
    },

    // Benchmark API

    Benchmark: {
      getAll: {
        type: "GET",
        endpoint: "/admin/benchmark",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/benchmark/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/benchmark",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/benchmark/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/benchmark/",
      },
    },

    // Benchmark Activity API

    BenchmarkActivity: {
      getAll: {
        type: "GET",
        endpoint: "/admin/benchmarkActivity",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/benchmarkActivity/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/benchmarkActivity",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/benchmarkActivity/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/benchmarkActivity/",
      },
    },

    // Plan API

    Plan: {
      getAll: {
        type: "GET",
        endpoint: "/admin/plan",
      },
    },
    // SubPlan API

    SubPlan: {
      getAll: {
        type: "GET",
        endpoint: "/admin/subPlan",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/subPlan/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/subPlan",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/subPlan/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/subPlan/",
      },
    },

    // FeedBack API

    Feedback: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userFeedback",
      },
    },

    // Device Type API

    DeviceType: {
      getAll: {
        type: "GET",
        endpoint: "/admin/deviceType",
      },
    },

    // Device API

    Device: {
      getAll: {
        type: "GET",
        endpoint: "/admin/device",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/device/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/device",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/device/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/device/",
      },
    },
    // App Config API

    Config: {
      getAll: {
        type: "GET",
        endpoint: "/admin/appConfig",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/appConfig/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/appConfig",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/appConfig/:id",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/appConfig/:id",
      },
    },

    // Notification API

    Notification: {
      sentNotification: {
        type: "POST",
        endpoint: "/admin/notification/addNotificationToTopic",
      },
    },
  },


  TAB_MENU: {
    USER: [
      {
        no: 1,
        Label: "Pets",
        name: "pets",
        id: "pets",
      },
      {
        no: 2,
        Label: "Feedback",
        name: "feedback",
        id: "feedback",
      },
      {
        no: 3,
        Label: "Subscription",
        name: "subscription",
        id: "subscription",
      },
      {
        no: 4,
        Label: "Transaction",
        name: "transaction",
        id: "transaction",
      },
    ],
    PET: [
      {
        no: 1,
        Label: "Food Tracking",
        name: "food",
        id: "food",
      },
      {
        no: 2,
        Label: "Weight Tracking",
        name: "weight",
        id: "weight",
      },
      {
        no: 3,
        Label: "Manually Tracking",
        name: "manually",
        id: "manually",
      },
      {
        no: 4,
        Label: "Device Details",
        name: "device",
        id: "device",
      },
    ],
  },
};
export default CONSTANTS;
